import {useEffect, useState} from 'react';
import logger from '../../../../../../logger';
import {getLoyaltyUser} from '../../../../../../services/loyalty';
import useSession from '../../../../../../stores/session/useSession';

export const useRedeemSection = (prizePoints: number): [boolean, number] => {
  const {token, user} = useSession();

  const isAuth = !!token && !!user;

  const [missingLoyaltyPoints, setMissingLoyaltyPoints] = useState<number>(0);

  useEffect(() => {
    const fetchLoyaltyUser = async () => {
      const {data, ok} = await getLoyaltyUser(user!._id);
      if (!ok) {
        logger.error(data);
        return;
      }
      const difference = data.loyaltyPointsAvailable - prizePoints;
      setMissingLoyaltyPoints(difference < 0 ? Math.abs(difference) : 0);
    };

    if (isAuth) {
      fetchLoyaltyUser();
    }
  }, []);

  return [isAuth, missingLoyaltyPoints];
};
